<template>
    <div class="hotel-description-page">
        <breadcrumbs class="pb-3" :text="productName" />
        <v-row>
            <v-col cols="12" md="12">
                <div class="d-flex align-center">
                    <h1 class="me-2">{{ productName }}</h1>
                </div>
            </v-col>
        </v-row>
        <v-tabs v-model="productTab" color="primary">
            <v-tab :value="'tab-' + 'information'">{{ $t('information') }}</v-tab>
            <v-tab :value="'tab-' + 'description'">
                {{ $t('description') }}
            </v-tab>
            <v-tab :value="'tab-' + 'photo'">
                {{ $t('photo') }}
            </v-tab>
        </v-tabs>
        <v-tabs-window v-model="productTab">
            <v-tabs-window-item value="tab-information">
                <SecondLevelTabs :tabs="secondLevelInfoTabs" translation-key="product_tabs">
                    <template v-slot:info>
                        <InfoContractForm
                            v-if="hotelInfo"
                            :is-hotel-description-mode="true"
                            :contract-id="0"
                            :service-type="contractServiceType.ownHotel"
                        />
                    </template>
                    <template v-slot:room_types>
                        <InfoServices service-type="ownHotel" />
                    </template>
                    <template v-slot:meal_types>
                        <InfoSecondaryServices service-type="ownHotel" />
                    </template>
                    <template v-slot:tags>
                        <ProductHotelTagsForm />
                    </template>
                </SecondLevelTabs>
            </v-tabs-window-item>
            <v-tabs-window-item value="tab-description">
                <ProductHotelDescription />
            </v-tabs-window-item>
            <v-tabs-window-item value="tab-photo">
                <product-images-form service-type="ownHotel" class="pt-4" />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import ProductHotelDescription from '~/components/products/hotels/ProductHotelDescription.vue'
    import InfoContractForm from '~src/components/products/information/InfoContractForm.vue'
    import {contractServiceType} from '~/utils/types/types'
    import InfoSecondaryServices from '~/components/products/information/InfoSecondaryServices.vue'
    import InfoServices from '~src/components/products/information/InfoServices.vue'
    import ProductImagesForm from '~src/components/supplier/ProductImagesForm.vue'
    import ProductHotelTagsForm from '~/components/products/hotels/ProductHotelTagsForm.vue'

    const productName = ref('test')
    const hotelInfo = ref(null)
    const productTab = ref(null)
    const secondLevelInfoTabs = ref(['info', 'room_types', 'meal_types', 'tags'])

    const {params} = useRoute()
    const {t} = useI18n()

    provide('isHotelDescriptionMode', true)
    provide('hotelDescriptionId', params.hotelId)

    onMounted(async () => {
        if (params.hotelId) {
            await supplierStore.loadHotelInfo(params.hotelId)
        }
        hotelInfo.value = supplierStore.hotelInfo
        productName.value = hotelInfo.value?.hotelName
            ? getName(hotelInfo.value.hotelName)
            : `${t('hotel')} ${hotelInfo.value.hotelId || ''}`
    })

    const getName = (name): string => {
        if (!name) return ''
        if (name?.en) return name.en
        const firstAvailableKey = Object.keys(name)[0]
        return name[firstAvailableKey]
    }
</script>
